import React from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { IDataMergeViewModel } from "services/api/types";
import { allModules as api } from "services/api";
import { Page } from "components/Shell/Page";
import { RouteComponentProps } from "utils/routerCompat";
import { DataMerge } from "./DataMerge";
import Typography from "@mui/material/Typography";

type Props = RouteComponentProps<{ dataMergeId: string }>;

const MergeConflictsContainer = (props: Props) => {
  const [dataMerge, setDataMerge] = React.useState<
    IDataMergeViewModel | undefined
  >();

  React.useEffect(() => {
    const load = async (dataMergeId: string) => {
      const result =
        await api.admin.mergeConflicts.getMergeConflicts(dataMergeId);
      setDataMerge(result);
    };

    load(props.match.params.dataMergeId);
  }, [props.match.params.dataMergeId]);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {},
      instructions: {
        marginBottom: theme.spacing(4),
      },
    }),
  );

  const handleUseDiscardedValue = async (mergeActionId: string) => {
    await api.admin.mergeConflicts.useDiscardedValue(mergeActionId);
    // Just refetch all conflicts
    const result = await api.admin.mergeConflicts.getMergeConflicts(
      props.match.params.dataMergeId,
    );
    setDataMerge(result);
  };

  const classes = useStyles();

  return (
    <Page
      title="Merge Conflicts"
      isLoading={dataMerge === undefined}
      render={() => {
        return (
          <div className={classes.root}>
            <Typography className={classes.instructions}>
              The merge is complete. Below are the fields where the system had
              to choose between two values. If the incorrect value was selected,
              click Use Discarded Value to restore the discarded value.
            </Typography>
            {dataMerge && (
              <>
                <DataMerge
                  useDiscardedValue={handleUseDiscardedValue}
                  dataMerge={dataMerge}
                />
                {dataMerge.childMerges.map((child) => {
                  return (
                    <DataMerge
                      dataMerge={child}
                      useDiscardedValue={handleUseDiscardedValue}
                    />
                  );
                })}
              </>
            )}
          </div>
        );
      }}
    />
  );
};

export { MergeConflictsContainer };
